import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const degreeSlice = createSlice({
  name: "academic",
  initialState: {
    degree: {
      data: [],
      loading: false,
      error: null,
    },
    registration: {
      data: [],
      loading: false,
      error: null,
    },
    degreeName: {
      data: [],
      loading: false,
      error: null,
    },
  },
  reducers: {
    fetchDegreeStart(state) {
      state.degree.loading = true;
      state.degree.error = null;
    },
    fetchDegreeSuccess(state, action) {
      state.degree.loading = false;
      state.degree.data = action.payload;
    },
    fetchDegreeFailure(state, action) {
      state.degree.loading = false;
      state.degree.error = action.payload;
    },

    fetchDegreeNameStart(state) {
      state.degreeName.loading = true;
      state.degreeName.error = null;
    },
    fetchDegreeNameSuccess(state, action) {
      state.degreeName.loading = false;
      state.degreeName.data = action.payload;
   
    },
    fetchDegreeNameFailure(state, action) {
      state.degreeName.loading = false;
      state.degreeName.error = action.payload;
    },

    postRegistrationStart(state) {
      state.registration.loading = true;
      state.registration.error = null;
    },
    postRegistrationSuccess(state, action) {
      state.registration.loading = false;
      state.registration.data.push(action.payload);
    },
    postRegistrationFailure(state, action) {
      state.registration.loading = false;
      state.registration.error = action.payload;
    },
  },
});

export const {
  fetchDegreeStart,
  fetchDegreeSuccess,
  fetchDegreeFailure,
  postRegistrationStart,
  postRegistrationSuccess,
  postRegistrationFailure,
  fetchDegreeNameStart,
  fetchDegreeNameSuccess,
  fetchDegreeNameFailure,
} = degreeSlice.actions;

export const fetchDegreeData = () => async (dispatch) => {
  dispatch(fetchDegreeStart());
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/academicPage/getDegreePrograms`
    );
    //console.log("API Response:", response.data); // Debug log
    const data = response.data.data || [];
    dispatch(fetchDegreeSuccess(data));
  } catch (error) {
    console.error("API Error:", error);
    dispatch(fetchDegreeFailure(error.message || "Something went wrong"));
  }
};

export const fetchDegreeNames = () => async (dispatch) => {
  dispatch(fetchDegreeNameStart());
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/academicPage/getDegreeNames`
    );
    const data = response.data.data || []; // Defaults to empty array if no data
    dispatch(fetchDegreeNameSuccess(data));
    console.log(data)
  } catch (error) {
    dispatch(fetchDegreeNameFailure(error.message || "Something went wrong"));
  }
};

export const postDegreeRegistration =
  (registrationData) => async (dispatch) => {
    dispatch(postRegistrationStart());
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/academicPage/addStudentApplication`,
        registrationData
      );

      if (response.data.success) {
        dispatch(postRegistrationSuccess(response.data)); // Dispatch success action
        return { success: true, message: response.data.message }; // Return success response
      }

      // If success is false, handle it as an error
      return {
        success: false,
        message: response.data.message || "Registration failed.",
      };
    } catch (error) {
      // Handle 400 error specifically
      if (error.response && error.response.status === 400) {
        const errorMessage =
          "Missing required field(s). Please check your input.";
        dispatch(postRegistrationFailure(errorMessage));
        return { success: false, message: errorMessage };
      }
      dispatch(
        postRegistrationFailure(error.message || "Something went wrong")
      );
      return {
        success: false,
        message: error.message || "Something went wrong",
      }; // Return failure response
    }
  };

export default degreeSlice.reducer;
